import React, { useContext } from "react";
import { Card, Space, Progress, Result, Button } from "antd";
import { withRouter } from "../../../../helpers";
import { OnboardingContext } from "../../../../contexts/expert/onboarding";

function Success({ navigate }) {
  const { data } = useContext(OnboardingContext);

  const onNavigate = () => {
    const expertId = data?.user?.id || "";
    navigate(`/v2/expert/${expertId}/profile`);
  };

  return (
    <Card bordered={false} style={{maxWidth: "600px", margin: "0 auto"}}>
      <Space direction="vertical" size="large">
        <Progress percent={100} showInfo={false} />
        <>
          <Result
            status="success"
            title="¡Yay! ¡Has creado tu cuenta con éxito!"
            subTitle="Estás listo para ayudar al próximo unicornio de EOS"
            extra={
              <Button
                onClick={onNavigate}
                type="primary">
                Comenzar
              </Button>
            } />
        </>
      </Space>
    </Card>
  );
}

export default withRouter(Success);
